import React from "react";
import { useTranslation } from "@emisgroup/acp-application-intl";
import {
  Dialog,
  DialogInner,
  DialogHeader,
  DialogContent
} from "../../Common/UI/Index";
import ExtractAdd, { IExtractAddProp } from "./ExtractAdd.logic";
import AddSecondary from "~icons/ic/baseline-add-circle-outline";
import "./Style.scss";

export interface IExtractAddDialogProp extends IExtractAddProp {

  /**
   * Flag to display create extract dialog
   */
  show: boolean;

  /**
   * Flag to display create extract dialog
   */
  isIconOnly: boolean;
}

type Props = IExtractAddDialogProp;

/**
 * Responsible for rendering Extract Add dialog
 */
const ExtractAddDialogView = (prop: Props): JSX.Element => {

  const {
    isEdit,
    onClose: toggleDialog,
    show,
    yearsDataValue,
    isIconOnly,
    notification
  } = prop;

  const { t: translate } = useTranslation();

  return (
    <>
      {!isIconOnly &&
        <AddSecondary
          className="ebt-extract-add__icon"
          title="Create extract"
          size="large"
          onClick={toggleDialog}
          color="mono"
        />
      }
      <Dialog
        open={show}
        onOpenChange={toggleDialog}
        className="ebt-extract-add"
      >
        <DialogInner className="ebt-extract-add-inner">
          <DialogHeader
            className="ebt-extract-add-header"
          >
            <div>
              {translate("Extract.ExtractAdd.Header")}
            </div>
          </DialogHeader>
          <DialogContent>
            <ExtractAdd
              yearsDataValue={yearsDataValue}
              onClose={toggleDialog}
              isEdit={isEdit}
              notification={notification}
            />
          </DialogContent>
        </DialogInner>
      </Dialog>
    </>
  );
};

export default ExtractAddDialogView;
